import { Box, Heading } from '@chakra-ui/react';
import { FC, useState } from 'react';
import { Step, Steps, useSteps } from 'chakra-ui-steps';
import Deployment from 'components/onboarding/deployment';
import Summary from 'components/onboarding/summary';
import { ProgramToken } from 'types';
import Introduction from 'components/onboarding/Introduction';
import { useWeb3React } from 'hooks/web3';
import { convertChainIdToNetworkName } from 'utils/convertChainIdToNetworkName';
import { useAludelTemplates } from 'hooks/query/useAludelTemplates';

export type DeploymentData = {
  name: string;
  startTime: number;
  stakingToken: ProgramToken;
  getStakingTokenUrl: string;
  rewardToken: ProgramToken;
  rewardTokenAmount: number;
  unlockDays: number;
  bonusTokens: (ProgramToken & { amount: number })[];
  scalingFloor: number;
  scalingCeiling: number;
  scalingDays: number;
  programAddress: string;
  ownerAddress: string;
  templateId: string;
  templateName: string;
};

const Onboarding: FC = () => {
  const { chainId = 1 } = useWeb3React();
  const { nextStep, activeStep } = useSteps({ initialStep: 0 });

  // Preload aludel templates
  useAludelTemplates();

  const [deploymentData, setDeploymentData] = useState<DeploymentData>({
    name: '',
    startTime: 0,
    stakingToken: {
      address: '',
      tokenSymbol: '',
      decimals: 18
    },
    getStakingTokenUrl: '',
    rewardToken: {
      address: '',
      tokenSymbol: '',
      decimals: 18
    },
    rewardTokenAmount: 0,
    unlockDays: 0,
    bonusTokens: [],
    scalingFloor: 0,
    scalingCeiling: 0,
    scalingDays: 0,
    programAddress: '',
    ownerAddress: '',
    templateId: '',
    templateName: ''
  });

  return (
    <Box p={[4, null, 10]} bg='gray.800' borderRadius='xl'>
      <Heading size='xl' textAlign='center' py={8}>
        {activeStep === 0 &&
          `Create a new program on ${convertChainIdToNetworkName(chainId)}`}
        {activeStep === 1 &&
          `Deploy program to ${convertChainIdToNetworkName(chainId)}`}
        {activeStep === 2 && 'Summary'}
      </Heading>

      <Steps activeStep={activeStep} mb={20}>
        <Step label='Introduction'>
          <Introduction nextStep={nextStep} />
        </Step>
        <Step label='Deployment'>
          <Deployment
            nextStep={nextStep}
            deploymentData={deploymentData}
            setDeploymentData={setDeploymentData}
          />
        </Step>
        <Step label='Summary'>
          <Summary deploymentData={deploymentData} />
        </Step>
      </Steps>
    </Box>
  );
};

export default Onboarding;
